import React, { useState, useRef } from 'react';
import { authenticatedApiCall } from '../../../utils/apiClient';

const FormatTestPanel = ({ formatId, config, instance, accounts }) => {
  const [testFile, setTestFile] = useState(null);
  const [running, setRunning] = useState(false);
  const [results, setResults] = useState(null);
  const [error, setError] = useState(null);
  const fileRef = useRef(null);

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (file && file.type === 'application/pdf') {
      setTestFile(file);
      setError(null);
    } else {
      setError('Please select a PDF file');
    }
  };

  const handleRunTest = async () => {
    if (!testFile) { setError('Select a PDF first'); return; }
    setRunning(true);
    setError(null);
    setResults(null);
    try {
      const formData = new FormData();
      formData.append('file', testFile);
      formData.append('config', JSON.stringify(config));
      const res = await authenticatedApiCall(instance, accounts, 'POST', '/pdf-extractor/builder/test-extraction', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
      if (res.data.success) {
        setResults(res.data.data.results || res.data.data);
      } else {
        setError(res.data.error || 'Test extraction failed');
      }
    } catch (err) {
      setError(err.response?.data?.details || err.message || 'Test extraction failed');
    } finally {
      setRunning(false);
    }
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <h4 style={{ fontSize: 14, fontWeight: 600, margin: 0, color: '#495057' }}>Test Extraction</h4>
      </div>

      <div style={{ backgroundColor: '#f8f9fa', border: '1px solid #e9ecef', borderRadius: 8, padding: 20, marginBottom: 16 }}>
        <div style={{ marginBottom: 16 }}>
          <label style={{ display: 'block', marginBottom: 8, fontWeight: 500, fontSize: 14 }}>Upload Test PDF</label>
          <input ref={fileRef} type="file" accept=".pdf" onChange={handleFileSelect} style={{ width: '100%', padding: 8, border: '1px solid #ced4da', borderRadius: 4 }} />
          {testFile && <div style={{ marginTop: 6, fontSize: 13, color: '#198754' }}>Selected: {testFile.name}</div>}
        </div>
        <button onClick={handleRunTest} disabled={!testFile || running} style={{
          padding: '10px 24px', backgroundColor: (!testFile || running) ? '#6c757d' : '#198754',
          color: '#fff', border: 'none', borderRadius: 6, fontSize: 14, fontWeight: 500,
          cursor: (!testFile || running) ? 'not-allowed' : 'pointer',
        }}>
          {running ? 'Running Extraction...' : 'Run Test Extraction'}
        </button>
      </div>

      {error && (
        <div style={{ padding: '12px 16px', backgroundColor: '#f8d7da', border: '1px solid #f5c2c7', borderRadius: 6, color: '#842029', marginBottom: 16 }}>{error}</div>
      )}

      {results && (
        <div>
          <h4 style={{ fontSize: 14, fontWeight: 600, marginBottom: 8, color: '#495057' }}>Extraction Results</h4>
          <pre style={{
            backgroundColor: '#1e1e1e', color: '#d4d4d4', padding: 16, borderRadius: 8,
            overflow: 'auto', maxHeight: 500, fontSize: 13, lineHeight: 1.5, whiteSpace: 'pre-wrap',
          }}>
            {JSON.stringify(results, null, 2)}
          </pre>
        </div>
      )}
    </div>
  );
};

export default FormatTestPanel;
